import { createSelector } from '@reduxjs/toolkit';
import { employeesShortNames } from './employees-short-names';
import { currentEmployeeUuid } from './current-employee-uuid';
import type { NameEntry } from './name-entry';
import { employeesShortNamesAndCurrentUserPronoun } from './employees-short-names-and-current-user-pronoun';

export const employeesShortNamesAndI = createSelector(
  employeesShortNames,
  currentEmployeeUuid,
  function (employeesShortNames: NameEntry[], currentEmployeeUuid): NameEntry[] {
    if (currentEmployeeUuid === undefined) {
      return employeesShortNames;
    }
    return employeesShortNamesAndCurrentUserPronoun(employeesShortNames, currentEmployeeUuid, 'jeg');
  },
);
